// Card.jsx

import React from "react";

const Card = ({ title, description, link, gaClick }) => {
  return (
    <div className="col-xl-4">
      <div className="inner mb-4">
        <h3 className="section-title  ">{title}</h3>
        <p>{description}</p>
        {/* <a
          // href={link}
          className="btn btn_blue"
          data-ga-click={gaClick}
          target="_blank"
          rel="noopener noreferrer"
        >
          Business Models
        </a> */}
      </div>
    </div>
  );
};

export default Card;
